<template>
  <div class="app flex-row align-items-center" style="background-color: rgb(246,246,246) !important">
    <div class="container">
      <div class="login">
        <div class="wrapper wrapper-login bg_img">
          <div class="container container-login">
            <div class="bg_icon">
              <img src="/f1/assets/img/login_icon.png" class="mx-auto d-block ">
            </div>
            <h3 class="text-center login_tit">비밀번호 재설정</h3>
            <p class="font_20 font-weight-bold text-center">{{custom && custom.slogan ? custom.slogan : 'F1-UWSS'}}</p>
            <h3 class="text-center login_sub">재설정시 기존 OTP 도 초기화돼요.</h3>
            <!-- 패스워드 초기화 OTP 초기화 -->
            <div v-if="!reset" class="login-form">
              <div class="form-group mb-1">
                <input :disabled="reset || lock_btn" type="text" class="form-control" placeholder="이메일을 입력하세요" v-model="model.username" @keyup.enter="otpToken()">
              </div>
              <!-- <div class="form-group py-2">
                <div class="custom-control custom-radio"></div>
                <div class="custom-control custom-radio" style="text-align : center; display : inline-block;">
                  <Language />
                </div>
              </div> -->
              <div class="form-group form-action-d-flex mt-3">
                <b-button :disabled="reset || lock_btn" variant="primary" class="btn btn-primary btn-lg btn-block" @click="otpToken()">제출</b-button>
              </div>
              <div class="login-account font_16">
                <b-button variant="link" v-if="custom.version" class="link text-secondary" disabled>v{{ custom.version }}</b-button>
                <span class="px-1 dot">·</span>
                <div class="custom-control custom-radio" style="text-align : center; display : inline-block;">
                  <Language />
                </div>
                <span class="px-1 dot">·</span>
                <b-button variant="link" class="link" @click="$router.push({ name: 'auth_login'})">로그인</b-button>
              </div>
            </div>
            <!-- 패스워드 초기화 중 비밀번호 초기화 -->
            <div v-if="reset" class="login-form">
              <div class="form-group mb-1">
                <input type="password" class="form-control" placeholder="새 비밀번호를 입력하세요" v-model="model.password_new">
              </div>
              <div v-if="model.password_new" class="form-group mb-1">
                <input type="password" class="form-control" placeholder="비밀번호 재입력하세요." v-model="model.password_new_repeat" @keyup.enter="newPassword()">
              </div>
              <!-- <hr v-if="reset && model.password_new"> -->
              <small>
                <b-badge v-if="model.password_new"  :variant="password_policy('number') ? 'success' : 'danger'"> 숫자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> 대문자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> 소문자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('spacial') ? 'success' : 'danger'"> 특수 문자 </b-badge>
                <b-badge v-if="model.password_new"  :variant="password_policy('length') ? 'success' : 'danger'">
                  최소 글자 : 10글자
                </b-badge>
              </small>
              <!-- <div class="form-group py-2">
                <div class="custom-control custom-radio">
                  <Language />
                </div>
              </div> -->
              <div class="form-group form-action-d-flex mt-3">
                <b-button variant="primary" class="form-control" @click="newPassword()">제출</b-button>
              </div>
              <div class="login-account font_16">
                <b-button variant="link" v-if="custom.version" class="link text-secondary" disabled>v{{ custom.version }}</b-button>
                <span class="px-1 dot">·</span>
                <div class="custom-control custom-radio" style="text-align : center; display : inline-block;">
                  <Language />
                </div>
                <span class="px-1 dot">·</span>
                <b-button variant="link" class="link" @click="$router.push({ name: 'auth_login'})">로그인</b-button>
              </div>
            </div>
            <b-col class="bg_logo">
              <img src="/f1/assets/img/F1-uwss.png" class="mx-auto d-block" height="30" alt="">
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>